module.exports = __webpack_public_path__ + "static/seo-industries-cdc41d587f7575ca15a9850dd5dcb917.png";